const GREEN = "#18D889";

export default function CondenseIconMark({ size = 20, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      className={className}
      style={{ flexShrink: 0, display: "block" }}
    >
      <path
        d="M8 5.5 L16.5 12 L8 18.5"
        stroke={GREEN}
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
